export default __webpack_public_path__ + "static/media/node.cccdafa9.svg";